import videojs from 'video.js';

import { EWaitDelay, REWIND_TIME } from './constants';

export const stimulateNav = (player: videojs.Player) => {
    player.reportUserActivity(true);
};

export const hideNav = (player: videojs.Player) => {
    player.userActive(false);
    player.userActivity_ = false;
};

export const toggleNav = (player: videojs.Player) => {
    if (player.userActive()) {
        hideNav(player);
    } else {
        stimulateNav(player);
    }
};

export const goBackward = (player: videojs.Player): boolean => {
    const currentTime = player.currentTime();
    if (currentTime > EWaitDelay.BEFORE_FORGET / 1000) {
        player.trigger('rewindbackward');
        player.currentTime(currentTime - REWIND_TIME);
        return true;
    }
    return false;
};

export const goForward = (player: videojs.Player): boolean => {
    const currentTime = player.currentTime();
    const remainingTime = player.remainingTime();
    if (remainingTime > EWaitDelay.BEFORE_FORGET / 1000) {
        player.trigger('rewindforward');
        player.currentTime(currentTime + REWIND_TIME);
        return true;
    }
    return false;
};

export const togglePlay = (player: videojs.Player) => {
    if (player.paused()) {
        player.play();
    } else {
        player.pause();
    }
};
